import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-base-refresh-component',
    templateUrl: './base-refresh.component.html',
    standalone: false
})
export abstract class BaseRefreshComponent implements OnInit, OnDestroy {
  destroy = new Subject<void>();
  protected refreshEnabled: boolean;
  protected constructor() {}
  abstract setData(): void;

  ngOnInit(): void {
    interval(60000).pipe(
      filter(() => this.refreshEnabled),
      takeUntil(this.destroy)
    ).subscribe(() => (this.setData()));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
